import { VERSION } from '../environments/version';
import { Component } from '@angular/core';
import { E2eService } from './shared/services/e2e/e2e.service';
import { CancellationService } from './shared/services/cancellation/cancellation.service';
import { RescheduleService } from './shared/services/reschedule/reschedule.service';
import { RoutingStateService } from './shared/services/routing-state/routing-state.service';
import { environment } from '../environments/environment';
import { StringsService } from './shared/services/strings/strings.service';
import { DeepLinkService } from './shared/services/deep-link/deep-link.service';
import { AppInsightsMonitoringService } from './shared/services/logging/appInsightsMonitoring.service';

@Component({
    selector: 'rttd-root',
    templateUrl: './app.component.html',
    styleUrls: [
        './app.component.scss',
        require(`./app.component.${environment.brand}.scss`).default.toString()
    ]
})
export class AppComponent {
    version = VERSION;
    title = 'Real time test drive';

    constructor(
        public e2eService: E2eService,
        private cancellationService: CancellationService,
        private rescheduleService: RescheduleService,
        private routingState: RoutingStateService,
        private deeplinkService: DeepLinkService,
        private strings: StringsService,
        private appInsightsMonitoringService: AppInsightsMonitoringService
    ) {
        routingState.loadRouting();
        // Preload strings;
        this.strings.get().subscribe();
    }
}
